export enum RequestAccessTypesEnum {
  CUSTOMER = 'CUSTOMER',
  SUPPLIER = 'SUPPLIER',
  DRIVER = 'DRIVER',
  CARRIER = 'CARRIER',
  FACTORING_COMPANY = 'FACTORING COMPANY'
}
